import { render, staticRenderFns } from "./RestaurantStatusSwitch.vue?vue&type=template&id=bd405658"
import script from "./RestaurantStatusSwitch.vue?vue&type=script&lang=ts"
export * from "./RestaurantStatusSwitch.vue?vue&type=script&lang=ts"
import style0 from "./RestaurantStatusSwitch.vue?vue&type=style&index=0&id=bd405658&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports